import { Grid as Grid$1 } from '@shopify/ui-extensions/checkout';
import { createRemoteReactComponent } from '@remote-ui/react';

const Grid = createRemoteReactComponent(Grid$1);

export { Grid };
